import * as axios from 'axios';
import ExampleService from '@/services/ExampleService';

export const exampleService = new ExampleService(axios);
